/* global */
import Vue from 'vue'

const widget = {
  alert(message, btntext, complete) {
    Vue.prototype.$alert(message, '', {
      confirmButtonText: btntext ? btntext : '确定',
      callback: () => {
        complete && complete()
      }
    });
  },
  confirm(message, btntexts, complete, cancel) {
    Vue.prototype.$confirm(message, '', {
      confirmButtonText: btntexts[0] ? btntexts[0] : '确定',
      cancelButtonText: btntexts[1] ? btntexts[1] : '取消'
    }).then(() => {
      complete && complete()
    }).catch((action) => {
      if (action == 'cancel') {
        cancel && cancel()
      }
    });
  }
  
}

export default widget
